// Shared by Cloud Functions and the frontend (imported there as @shared).
// How teams are ordered in standings and seeded for the postseason. Works
// on team documents or summary rows ({name, record}).

/**
 * @param {number} w
 * @param {number} l
 * @return {number} winning percentage, 0 with no games
 */
export function winPct(w, l) {
  return w + l ? w / (w + l) : 0;
}

/**
 * Conference standings order: conference win%, then overall win%, then
 * point differential, then name.
 * @param {object} a
 * @param {object} b
 * @return {number}
 */
export function compareConference(a, b) {
  const ra = a.record;
  const rb = b.record;
  return winPct(rb.confW, rb.confL) - winPct(ra.confW, ra.confL) ||
    compareOverall(a, b);
}

/**
 * League-wide order (pro playoff seeding): overall win%, then point
 * differential, then name.
 * @param {object} a
 * @param {object} b
 * @return {number}
 */
export function compareOverall(a, b) {
  const ra = a.record;
  const rb = b.record;
  return winPct(rb.w, rb.l) - winPct(ra.w, ra.l) ||
    (rb.pf - rb.pa) - (ra.pf - ra.pa) ||
    a.name.localeCompare(b.name);
}
